import { Card, CardContent, makeStyles, Box, Typography } from '@material-ui/core';
import { AV_LOGO } from '../../constants/image-paths';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        overflow: 'auto',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#f4f5f7',
            backgroundImage: `url('/images/light-bg.jpg')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            // dark image to light
            //backgroundBlendMode: theme.palette.type === 'dark' ? undefined : 'difference'
            // light image to dark
            backgroundBlendMode: theme.palette.type === 'dark' ? 'multiply' : undefined
        }
    },
    card: {
        backdropFilter: theme.palette.type === 'dark' ? 'blur(14px)' : 'blur(4px)',
        backgroundColor: theme.palette.type === 'dark' ? '#3a3c3c99' : '#fff6'
    },
    logo: {
        width: 32,
        userSelect: 'none'
    }
}));

export default function Layout({ title, children }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Card className={classes.card}>
                <CardContent>
                    <Box display='flex' flexDirection='row' alignItems='center' m={2} gridGap={8}>
                        <img src={AV_LOGO} className={classes.logo} alt='Asset Vue' />
                        <Typography variant='h5' color='primary'>
                            {title}
                        </Typography>
                    </Box>
                    {children}
                </CardContent>
            </Card>
        </div>
    );
}
